export const trainingMonths = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// UserRoles

export const adminRole = "Admin";
export const shipOwnerRole = "ShipOwner";
export const yardOwnerRole = "YardInCharge";
export const supervisorRole = "Supervisor";

// Admin Master Data

export const lookupYard = "/lookupdata/yard";
export const lookupRoles = "/lookupdata/roles";
export const lookupTrainings = "/lookupdata/trainings";
export const lookupCFP = "/lookupdata/cfp";

export const roleTypeString = "RoleType";

// Yard

export const yardRoles = "/yard/roles";
export const yardTrainings = "/yard/trainings";
export const yardTrainingPlan = "/yard/trainingplan";

export const trainingStatus = "/trainingstatus";

export const additionalRoles = "/additionalroles";
export const additionalRole = "/additionalrole";
export const yardCommonRoles = "/commonroles";
export const yardCommonRole = "/commonrole";

export const additionalTrainings = "/additionaltrainings";
export const additionalTraining = "/additionaltraining";
export const yardMandatoryTrainings = "/mandatorytrainings";
export const yardMandatoryTraining = "/mandatorytraining";

export const yardTrainingPlanEdit = "/yard/trainingplan/planneddate/";
export const yardTrainingPlanEditActual = "/yard/trainingplan/actualdate/";

export const viewTrainingStatus = "/trainingstatus/viewactual";

export const yard = {
    "YardAdditionalRoles": {
        "AddedRoleIds": [
            0
        ],
        "DeletedRoleIds": [
            0
        ],
    },
    "CommonRoles": {
        "AddedRoleIds": [
            0
        ],
        "DeletedRoleIds": [
            0
        ],
    },
    "Title": "string"
}


export const yard1 = {
    "YardAdditionalRoles": {
        "AddedRoleIds": [
            0
        ],
        "DeletedRoleIds": [
            0
        ],
    },
    "CommonRoles": {
        "AddedRoleIds": [
            0
        ],
        "DeletedRoleIds": [
            0
        ],
    },
    "IsTitleModified": true,
    "Title": "string"
}

// Yard Training Plan 

export const yardDummyData = {
    "Pagination": {
        "has_previous": true,
        "has_next": false
    },
    "TrainingPlan": [
        {
            "TrainingId": 1,
            "TrainingTitle": "Sample",
            "TrainingDate": [
                {
                    "PlannedActual": [
                        {
                            "Id": 1,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        },
                        {
                            "Id": 2,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        }
                    ],
                    "Month": "Jan",
                    "Modify": null
                },
                {
                    "PlannedActual": [
                        {
                            "Id": 1,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        },
                        {
                            "Id": 2,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        }
                    ],
                    "Month": "Feb",
                    "Modify": null
                },
                {
                    "PlannedActual": [
                        {
                            "Id": 1,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        },
                        {
                            "Id": 2,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        }
                    ],
                    "Month": "Mar",
                    "Modify": null
                },
                {
                    "PlannedActual": [
                        {
                            "Id": 1,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        },
                        {
                            "Id": 2,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        }
                    ],
                    "Month": "Apr",
                    "Modify": null
                },
                {
                    "PlannedActual": [
                        {
                            "Id": 1,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        },
                        {
                            "Id": 2,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        }
                    ],
                    "Month": "May",
                    "Modify": null
                },
                {
                    "PlannedActual": [
                        {
                            "Id": 1,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        },
                        {
                            "Id": 2,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        }
                    ],
                    "Month": "Jun",
                    "Modify": null
                },
                {
                    "PlannedActual": [
                        {
                            "Id": 1,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        },
                        {
                            "Id": 2,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        }
                    ],
                    "Month": "Jul",
                    "Modify": null
                },
                {
                    "PlannedActual": [
                        {
                            "Id": 1,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        },
                        {
                            "Id": 2,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        }
                    ],
                    "Month": "Aug",
                    "Modify": null
                },
                {
                    "PlannedActual": [
                        {
                            "Id": 1,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        },
                        {
                            "Id": 2,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        }
                    ],
                    "Month": "Sep",
                    "Modify": null
                },
                {
                    "PlannedActual": [
                        {
                            "Id": 1,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        },
                        {
                            "Id": 2,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        }
                    ],
                    "Month": "Oct",
                    "Modify": null
                },
                {
                    "PlannedActual": [
                        {
                            "Id": 1,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        },
                        {
                            "Id": 2,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        }
                    ],
                    "Month": "Nov",
                    "Modify": null
                },
                {
                    "PlannedActual": [
                        {
                            "Id": 3,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        },
                        {
                            "Id": 4,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        }
                    ],
                    "Month": "Dec",
                    "Modify": null
                },
            ]
        },
        {
            "Id": 2,
            "TrainingTitle": "Sample 2",
            "TrainingDate": [
                {
                    "PlannedActual": [
                        {
                            "Id": 1,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        },
                        {
                            "Id": 2,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        }
                    ],
                    "Month": "Jan",
                    "Modify": null
                },
                {
                    "PlannedActual": [
                        {
                            "Id": 1,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        },
                        {
                            "Id": 2,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        }
                    ],
                    "Month": "Feb",
                    "Modify": null
                },
                {
                    "PlannedActual": [
                        {
                            "Id": 1,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        },
                        {
                            "Id": 2,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        }
                    ],
                    "Month": "Mar",
                    "Modify": null
                },
                {
                    "PlannedActual": [
                        {
                            "Id": 1,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        },
                        {
                            "Id": 2,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        }
                    ],
                    "Month": "Apr",
                    "Modify": null
                },
                {
                    "PlannedActual": [
                        {
                            "Id": 1,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        },
                        {
                            "Id": 2,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        }
                    ],
                    "Month": "May",
                    "Modify": null
                },
                {
                    "PlannedActual": [
                        {
                            "Id": 1,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        },
                        {
                            "Id": 2,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        }
                    ],
                    "Month": "Jun",
                    "Modify": null
                },
                {
                    "PlannedActual": [
                        {
                            "Id": 1,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        },
                        {
                            "Id": 2,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        }
                    ],
                    "Month": "Jul",
                    "Modify": null
                },
                {
                    "PlannedActual": [
                        {
                            "Id": 1,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        },
                        {
                            "Id": 2,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        }
                    ],
                    "Month": "Aug",
                    "Modify": null
                },
                {
                    "PlannedActual": [
                        {
                            "Id": 1,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        },
                        {
                            "Id": 2,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        }
                    ],
                    "Month": "Sep",
                    "Modify": null
                },
                {
                    "PlannedActual": [
                        {
                            "Id": 1,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        },
                        {
                            "Id": 2,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        }
                    ],
                    "Month": "Oct",
                    "Modify": null
                },
                {
                    "PlannedActual": [
                        {
                            "Id": 1,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        },
                        {
                            "Id": 2,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        }
                    ],
                    "Month": "Nov",
                    "Modify": null
                },
                {
                    "PlannedActual": [
                        {
                            "Id": 1,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        },
                        {
                            "Id": 2,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        },
                        {
                            "Id": 3,
                            "PlannedDate": "2022-11-29T00:00:00",
                            "ActualDate": "2022-11-29T00:00:00",
                        },
                    ],
                    "Month": "Dec",
                    "Modify": null
                },
            ]
        }
    ]
}
